export default "__VITE_ASSET__BN3lB2PQ__"